export class MaintenanceLine {
    id:number = 0;
    maintenance_id:number = 0;
    expense_type_id:number = 0;
    expense_type_name:string = '';
    article_id:number = 0;
    article_name:string = '';
    quantity:number = 0;
    price:number = 0;
    iva:number = 0.16;
    active:boolean = true;
    description:string = '';
    status:string = 'Creada';
    warehouse_id:number = 0;
    warehouse_name:string = '';
    entry_line_id:number = 0;
    entry_id:number = 0;
    unity_id:number = 0;
    discount:number = 0;
    measure_unit:string = '';
    warehouse_measure_unit:string = '';
    warehouse_factor:number = 1;
}
